module.exports = __webpack_public_path__ + "static/img/gril-icon.e7ff546c.svg";